export default __webpack_public_path__ + "static/media/x.0473bc5e.svg";